import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Redirect, Route} from 'react-router-dom';
import {getAuthenticated} from 'selectors/login';
import {getSettings} from 'selectors/settings';
import {allowsUnauthenticatedCoverageHome} from 'services/authentication';

const PrivateRoute = ({component: Component, ...rest}) => {
  const {authenticated, settings, ...restProps} = rest;

  return (
    <Route {...rest} render={(props) => {
      // If authenticated, always allow access
      if (authenticated) {
        return <Component {...restProps} {...props}/>;
      }

      // LoginV2: Allow / without auth only when overlays or HCP apply; full-page login types redirect to /login
      if (settings && props.location.pathname === '/' && allowsUnauthenticatedCoverageHome(settings)) {
        return <Component {...restProps} {...props}/>;
      }

      // Legacy workflow or other routes: Redirect to /login
      return (
        <Redirect to={{
          pathname: '/login',
          search: props.location.search,
          state: {from: props.location}}}
        />
      );
    }}
    />
  );
};

PrivateRoute.propTypes = {
  authenticated: PropTypes.bool.isRequired,
};

function mapStateToProps(state, ownProps) {
  return {
    authenticated: getAuthenticated(state),
    settings: getSettings(state),
    ...ownProps,
  };
}

export default connect(mapStateToProps)(PrivateRoute);
